import { Component } from '@angular/core';
import { ContactFormBaseComponent } from '../../../common-theme';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['../../../common-theme/base-components/shared/contact-form-base/contact-form-base.component.scss']
})

export class ContactFormComponent extends ContactFormBaseComponent { }



// WEBPACK FOOTER //
// ./src/app/shared/components/contact-form/contact-form.component.ts